import { render, staticRenderFns } from "./CreateWithholdPlan.vue?vue&type=template&id=678d6f66&scoped=true"
import script from "./CreateWithholdPlan.vue?vue&type=script&lang=js"
export * from "./CreateWithholdPlan.vue?vue&type=script&lang=js"
import style0 from "./CreateWithholdPlan.vue?vue&type=style&index=0&id=678d6f66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678d6f66",
  null
  
)

export default component.exports